import React from 'react';

const Clients = () => {
    return (
        <div className="container-fluid">
          <div className="block-header">
            <div className="row clearfix">
              <div className="col-md-6 col-sm-12">
                <h2>Clients</h2>
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">Oculux</li>
                    <li className="breadcrumb-item">Project</li>
                    <li className="breadcrumb-item active" aria-current="page">Clients</li>
                  </ol>
                </nav>
              </div>
              <div className="col-md-6 col-sm-12 text-right hidden-xs">
                <span className="btn btn-sm btn-primary mr-1" title>Create Campaign</span>
                <a href="https://themeforest.net/item/oculux-bootstrap-4x-admin-dashboard-clean-modern-ui-kit/23091507" className="btn btn-sm btn-success" title="Themeforest"><i className="icon-basket" /> Buy Now</a>
              </div>
            </div>
          </div>
          <div className="row clearfix">
            <div className="col-12">
              <div className="card">
                <div className="body">
                  <div className="row">
                    <div className="col-lg-4 col-md-4 col-sm-6">
                      <div className="input-group">
                        <input type="text" className="form-control" placeholder="Clinet Name" />
                      </div>
                    </div>
                    <div className="col-lg-5 col-md-4 col-sm-6">
                      <div className="input-group">
                        <input type="text" className="form-control" placeholder="Project" />
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-12">
                      <span className="btn btn-sm btn-primary mr-1" title>Search</span>
                      <span className="btn btn-sm btn-success" title>Add New</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6">
              <div className="card c_grid c_yellow">
                <div className="body text-center ribbon">
                  <div className="ribbon-box green">New</div>
                  <div className="circle">
                    <img className="rounded-circle" src="../assets/images/sm/avatar1.jpg" alt="" />
                  </div>
                  <h6 className="mt-3 mb-0">Michelle Green</h6>
                  <span><a href="/cdn-cgi/l/email-protection" className="__cf_email__" data-cfemail="0a606b796564277a65787e6f784a63646c6524696567">[email&nbsp;protected]</a></span>
                  <ul className="mt-3 list-unstyled d-flex justify-content-center">
                    <li><span className="p-3"><i className="fa fa-facebook" /></span></li>
                    <li><span className="p-3"><i className="fa fa-slack" /></span></li>
                    <li><span className="p-3"><i className="fa fa-linkedin" /></span></li>
                  </ul>
                  <button className="btn btn-default btn-sm">View Profile</button>
                  <button className="btn btn-default btn-sm">Message</button>
                  <div className="row text-center mt-4">
                    <div className="col-lg-6 border-right">
                      <label className="mb-0">Project</label>
                      <h4 className="font-20">07</h4>
                    </div>
                    <div className="col-lg-6">
                      <label className="mb-0">Profit </label>
                      <h4 className="font-20">$2,510</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6">
              <div className="card c_grid c_pink">
                <div className="body text-center ribbon">
                  <div className="ribbon-box indigo">India</div>
                  <div className="circle">
                    <img className="rounded-circle" src="../assets/images/sm/avatar3.jpg" alt="" />
                  </div>
                  <h6 className="mt-3 mb-0">David Wallace</h6>
                  <span><a href="/cdn-cgi/l/email-protection" className="__cf_email__" data-cfemail="2b664248434e47474e6b42454d4405484446">[email&nbsp;protected]</a></span>
                  <ul className="mt-3 list-unstyled d-flex justify-content-center">
                    <li><a className="p-3" href="/"><i className="fa fa-twitter" /></a></li>
                    <li><a className="p-3" href="/"><i className="fa fa-dribbble" /></a></li>
                    <li><a className="p-3" href="/"><i className="fa fa-slack" /></a></li>
                    <li><a className="p-3" href="/"><i className="fa fa-linkedin" /></a></li>
                  </ul>
                  <button className="btn btn-default btn-sm">View Profile</button>
                  <button className="btn btn-default btn-sm">Message</button>
                  <div className="row text-center mt-4">
                    <div className="col-lg-6 border-right">
                      <label className="mb-0">Project</label>
                      <h4 className="font-20">14</h4>
                    </div>
                    <div className="col-lg-6">
                      <label className="mb-0">Profit</label>
                      <h4 className="font-20">$7,510</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6">
              <div className="card c_grid c_cyan">
                <div className="body text-center">
                  <div className="circle">
                    <img className="rounded-circle" src="../assets/images/sm/avatar4.jpg" alt="" />
                  </div>
                  <h6 className="mt-3 mb-0">Michelle Green</h6>
                  <span><a href="/cdn-cgi/l/email-protection" className="__cf_email__" data-cfemail="96fcf7e5f9f8bbe6f9e4e2f3e4d6fff8f0f9b8f5f9fb">[email&nbsp;protected]</a></span>
                  <ul className="mt-3 list-unstyled d-flex justify-content-center">
                    <li><a className="p-3" href="/"><i className="fa fa-facebook" /></a></li>
                    <li><a className="p-3" href="/"><i className="fa fa-slack" /></a></li>
                    <li><a className="p-3" href="/"><i className="fa fa-linkedin" /></a></li>
                  </ul>
                  <button className="btn btn-default btn-sm">View Profile</button>
                  <button className="btn btn-default btn-sm">Message</button>
                  <div className="row text-center mt-4">
                    <div className="col-lg-6 border-right">
                      <label className="mb-0">Project</label>
                      <h4 className="font-20">08</h4>
                    </div>
                    <div className="col-lg-6">
                      <label className="mb-0">Profit</label>
                      <h4 className="font-20">$5,510</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6">
              <div className="card c_grid c_blue">
                <div className="body text-center">
                  <div className="circle">
                    <img className="rounded-circle" src="../assets/images/sm/avatar6.jpg" alt="" />
                  </div>
                  <h6 className="mt-3 mb-0">Michelle Green</h6>
                  <span><a href="/cdn-cgi/l/email-protection" className="__cf_email__" data-cfemail="264c475549480b564954524354664f4840490845494b">[email&nbsp;protected]</a></span>
                  <ul className="mt-3 list-unstyled d-flex justify-content-center">
                    <li><a className="p-3" href="/"><i className="fa fa-facebook" /></a></li>
                    <li><a className="p-3" href="/"><i className="fa fa-pinterest" /></a></li>
                    <li><a className="p-3" href="/"><i className="fa fa-linkedin" /></a></li>
                  </ul>
                  <button className="btn btn-default btn-sm">View Profile</button>
                  <button className="btn btn-default btn-sm">Message</button>
                  <div className="row text-center mt-4">
                    <div className="col-lg-6 border-right">
                      <label className="mb-0">Project</label>
                      <h4 className="font-20">05</h4>
                    </div>
                    <div className="col-lg-6">
                      <label className="mb-0">Profit</label>
                      <h4 className="font-20">$1,071</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6">
              <div className="card c_grid c_red">
                <div className="body text-center ribbon">
                  <div className="ribbon-box orange">Gold</div>
                  <div className="circle">
                    <img className="rounded-circle" src="../assets/images/sm/avatar5.jpg" alt="" />
                  </div>
                  <h6 className="mt-3 mb-0">Michelle Green</h6>
                  <span><a href="/cdn-cgi/l/email-protection" className="__cf_email__" data-cfemail="e68c87958988cb968994928394a68f888089c885898b">[email&nbsp;protected]</a></span>
                  <ul className="mt-3 list-unstyled d-flex justify-content-center">
                    <li><a className="p-3" href="/"><i className="fa fa-facebook" /></a></li>
                    <li><a className="p-3" href="/"><i className="fa fa-slack" /></a></li>
                    <li><a className="p-3" href="/"><i className="fa fa-linkedin" /></a></li>
                  </ul>
                  <button className="btn btn-default btn-sm">View Profile</button>
                  <button className="btn btn-default btn-sm">Message</button>
                  <div className="row text-center mt-4">
                    <div className="col-lg-6 border-right">
                      <label className="mb-0">Project</label>
                      <h4 className="font-20">31</h4>
                    </div>
                    <div className="col-lg-6">
                      <label className="mb-0">Profit</label>
                      <h4 className="font-20">$45,510</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6">
              <div className="card c_grid c_green">
                <div className="body text-center">
                  <div className="circle">
                    <img className="rounded-circle" src="../assets/images/sm/avatar1.jpg" alt="" />
                  </div>
                  <h6 className="mt-3 mb-0">Sean Black</h6>
                  <span><a href="/cdn-cgi/l/email-protection" className="__cf_email__" data-cfemail="9af0fbe9f5f4b7eaf5e8eeffe8daf3f4fcf5b4f9f5f7">[email&nbsp;protected]</a></span>
                  <ul className="mt-3 list-unstyled d-flex justify-content-center">
                    <li><a className="p-3" href="/"><i className="fa fa-facebook" /></a></li>
                    <li><a className="p-3" href="/"><i className="fa fa-slack" /></a></li>
                    <li><a className="p-3" href="/"><i className="fa fa-linkedin" /></a></li>
                  </ul>
                  <button className="btn btn-default btn-sm">View Profile</button>
                  <button className="btn btn-default btn-sm">Message</button>
                  <div className="row text-center mt-4">
                    <div className="col-lg-6 border-right">
                      <label className="mb-0">Project</label>
                      <h4 className="font-20">31</h4>
                    </div>
                    <div className="col-lg-6">
                      <label className="mb-0">Profit</label>
                      <h4 className="font-20">$45,510</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6">
              <div className="card c_grid c_indigo">
                <div className="body text-center ribbon">
                  <div className="ribbon-box pink">USA</div>
                  <div className="circle">
                    <img className="rounded-circle" src="../assets/images/sm/avatar2.jpg" alt="" />
                  </div>
                  <h6 className="mt-3 mb-0">Jason Porter</h6>
                  <span><a href="/cdn-cgi/l/email-protection" className="__cf_email__" data-cfemail="692a081b06052900070f06470a0604">[email&nbsp;protected]</a></span>
                  <ul className="mt-3 list-unstyled d-flex justify-content-center">
                    <li><a className="p-3" href="/"><i className="fa fa-skype" /></a></li>
                    <li><a className="p-3" href="/"><i className="fa fa-instagram" /></a></li>
                    <li><a className="p-3" href="/"><i className="fa fa-dribbble" /></a></li>
                  </ul>
                  <button className="btn btn-default btn-sm">View Profile</button>
                  <button className="btn btn-default btn-sm">Message</button>
                  <div className="row text-center mt-4">
                    <div className="col-lg-6 border-right">
                      <label className="mb-0">Project</label>
                      <h4 className="font-20">22</h4>
                    </div>
                    <div className="col-lg-6">
                      <label className="mb-0">Profit</label>
                      <h4 className="font-20">$12,510</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6">
              <div className="card c_grid c_cyan">
                <div className="body text-center">
                  <div className="circle">
                    <img className="rounded-circle" src="../assets/images/sm/avatar2.jpg" alt="" />
                  </div>
                  <h6 className="mt-3 mb-0">David Wallace</h6>
                  <span><a href="/cdn-cgi/l/email-protection" className="__cf_email__" data-cfemail="5e343f2d3130732e312c2a3b2c1e37303831703d3133">[email&nbsp;protected]</a></span>
                  <ul className="mt-3 list-unstyled d-flex justify-content-center">
                    <li><a className="p-3" href="/"><i className="fa fa-flickr" /></a></li>
                    <li><a className="p-3" href="/"><i className="fa fa-dropbox" /></a></li>
                    <li><a className="p-3" href="/"><i className="fa fa-apple" /></a></li>
                    <li><a className="p-3" href="/"><i className="fa fa-pinterest" /></a></li>
                  </ul>
                  <button className="btn btn-default btn-sm">View Profile</button>
                  <button className="btn btn-default btn-sm">Message</button>
                  <div className="row text-center mt-4">
                    <div className="col-lg-6 border-right">
                      <label className="mb-0">Project</label>
                      <h4 className="font-20">12</h4>
                    </div>
                    <div className="col-lg-6">
                      <label className="mb-0">Profit</label>
                      <h4 className="font-20">$1,840</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    )
}

export default Clients;